import { render, staticRenderFns } from "./MealOrderDetail.vue?vue&type=template&id=a723007c"
import script from "./MealOrderDetail.vue?vue&type=script&lang=js"
export * from "./MealOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./MealOrderDetail.vue?vue&type=style&index=0&id=a723007c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports